import axios from "axios";

// CAMBIA AQUÍ EL API BASE SI ES NECESARIO
export const API_BASE = "https://egt2axq41g.execute-api.us-east-1.amazonaws.com/dev";

// =========================
// INVENTARIO
// =========================
export const getInventario = () => axios.get(`${API_BASE}/inventario`);
export const createInventario = (data) => axios.post(`${API_BASE}/inventario`, data);
export const updateInventario = (id, data) => axios.put(`${API_BASE}/inventario/${id}`, data);
export const deleteInventario = (id) =>
  axios.delete(`${API_BASE}/inventario`, { data: { id } });
export const buscarPorSerie = (serie) =>
  axios.get(`${API_BASE}/inventario/buscar?serie=${serie}`);

// =========================
// EQUIPOS
// =========================
export const getEquipos = () => axios.get(`${API_BASE}/equipos`);
export const createEquipo = (data) => axios.post(`${API_BASE}/equipos`, data);
export const updateEquipo = (id, data) => axios.put(`${API_BASE}/equipos/${id}`, data);
export const deleteEquipo = (id) => axios.delete(`${API_BASE}/equipos/${id}`);

// =========================
// CONTRATOS
// =========================
export const getContratos = () => axios.get(`${API_BASE}/contratos`);
export const createContrato = (data) => axios.post(`${API_BASE}/contratos`, data);
export const updateContrato = (id, data) => axios.put(`${API_BASE}/contratos/${id}`, data);
export const deleteContrato = (id) => axios.delete(`${API_BASE}/contratos/${id}`);

// =========================
// INCIDENCIAS
// =========================
export const getIncidencias = () => axios.get(`${API_BASE}/incidencias`);
export const createIncidencia = (data) => axios.post(`${API_BASE}/incidencias`, data);
export const updateIncidenciaEstado = (data) =>
  axios.put(`${API_BASE}/incidencias/estado`, data);

// =========================
// CONFIGURACIÓN
// =========================
export const getConfig = () => axios.get(`${API_BASE}/config`);
export const createConfig = (data) => axios.post(`${API_BASE}/config`, data);

// =========================
// 🔐 C R E D E N C I A L E S
// =========================
export const getCredenciales = () => axios.get(`${API_BASE}/credenciales`);
export const createCredencial = (data) => axios.post(`${API_BASE}/credenciales`, data);
export const updateCredencial = (id, data) =>
  axios.put(`${API_BASE}/credenciales/${id}`, data);
export const deleteCredencial = (id) =>
  axios.delete(`${API_BASE}/credenciales/${id}`);
